import '../../css/teasers/news.css';

export class NewsTeaser {

  constructor() {
 
  }

}